import * as React from 'react'
import Slider, { Settings } from 'react-slick'
import './Carousel.scss'
import NextArrow from './NextArrow'
import PrevArrow from './PrevArrow'

interface IProps {
    icon?: string
    rand?: number
    isSearch? : boolean
}
class Carousel extends React.Component<IProps> {
    render() {
        const { children, icon } = this.props
        const settings: Settings = {
            arrows: true,
            autoplay: true,
            autoplaySpeed: 5000,
            dots: true,
            infinite: true,
            speed: 1000,
            slidesToScroll: 1,
            slidesToShow: 1,
            initialSlide: this.props.rand ? this.props.rand : 0,
            className: 'carousel',
            dotsClass: 'carousel__dots',
            nextArrow: <NextArrow icon={this.props.icon} isSearch={this.props.isSearch}/>,
            prevArrow: <PrevArrow icon={this.props.icon} isSearch={this.props.isSearch}/>,
            customPaging: (i) => {
                return (
                    <div className='carousel__dot' />
                )
            },
        }

        return (
            <Slider {...settings}>
                {children}
            </Slider>
        )
    }
}

export default Carousel
